import React from 'react';

import styled from 'styled-components';

import { ISanityImage } from '@rbi-ctg/menu';
import Picture from 'components/picture';

import theme from './theme';

const DefaultImageContainer = styled.div`
  width: 90%;
  max-width: 920px;
  margin: 0 auto;
  padding: 2.5rem 0rem;
  ${Styles.mobile`
    padding: 1.5rem 0rem;
  `}
`;
const Figure = styled.figure`
  position: relative;
  margin: 0;
`;
const Image = styled(Picture)`
  border-radius: ${Styles.borderRadius};
`;
const ImageCaption = styled.figcaption`
  padding-top: 1rem;
  font-size: 0.875rem;
  text-align: ${theme.imageWidgetCaptionAlign};
  & > a {
    color: ${Styles.color.primary};
    margin-right: 0.5rem;
  }
`;
const RewardsImageContainer = styled.div`
  background-color: ${Styles.color.highlight};
  padding: 2rem 0;
  figcaption {
    text-align: center;
    font-weight: bold;
    padding: 0 1.25rem;
    color: ${Styles.color.white};
    font-size: 0.9375rem;
    margin-top: 1rem;
  }
  ${Image} {
    max-width: 260px;
    width: 90%;
    margin: 0 auto;
  }
`;
enum PageSlug {
  RewardsRedemptions = 'rewards-redemptions',
}

const renderImageComponentBySlug = {
  [PageSlug.RewardsRedemptions]: RewardsImageContainer,
};

interface ImageContainerProps {
  children: React.ReactNode;
  currentPage: string;
}

const ImageContainer: React.FC<ImageContainerProps> = ({ children, currentPage }) => {
  const ImageComponent: React.FC | undefined = renderImageComponentBySlug[currentPage];

  return ImageComponent ? (
    <ImageComponent>{children}</ImageComponent>
  ) : (
    <DefaultImageContainer>{children}</DefaultImageContainer>
  );
};

interface ImageWidgetProps {
  attributionLink: string | null;
  caption?: {
    locale: string;
  };
  currentPage: string;
  image?: {
    locale: ISanityImage;
  };
}

const ImageWidget: React.FC<ImageWidgetProps> = ({
  attributionLink,
  caption,
  currentPage,
  image,
}) => {
  return (
    <ImageContainer currentPage={currentPage}>
      {image && (
        <Figure>
          <Image alt={caption?.locale || ''} image={image.locale} />
        </Figure>
      )}
      {caption && (
        <ImageCaption>
          {attributionLink && <a href={attributionLink}>Image Source</a>}
          {caption?.locale}
        </ImageCaption>
      )}
    </ImageContainer>
  );
};

export default ImageWidget;
